module.exports = __webpack_public_path__ + "img/banner-dire-new.7f670bd3.jpg";